"use strict";

var _slicedToArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _toConsumableArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.codec = exports.Codec = exports.validateSchema = void 0;

var lisk_validator_1 = require("@liskhq/lisk-validator");

var lisk_utils_1 = require("@liskhq/lisk-utils");

var utils_1 = require("./utils");

var collection_1 = require("./collection");

var json_wrapper_1 = require("./json_wrapper");

var validateSchema = function validateSchema(schema) {
  var _a;

  lisk_validator_1.validator.removeSchema(schema.$id);

  var schemaToValidate = _objectSpread({}, schema, {
    $schema: (_a = schema.$schema) !== null && _a !== void 0 ? _a : lisk_validator_1.liskSchemaIdentifier
  });

  var errors = lisk_validator_1.validator.validateSchema(schemaToValidate);

  if (errors.length) {
    throw new lisk_validator_1.LiskValidationError(_toConsumableArray(errors));
  }

  try {
    lisk_validator_1.validator.compile(schemaToValidate);
  } finally {
    lisk_validator_1.validator.removeSchema(schema.$id);
  }

  return true;
};

exports.validateSchema = validateSchema;

var Codec = /*#__PURE__*/function () {
  function Codec() {
    _classCallCheck(this, Codec);

    this._compileSchemas = {};
  }

  _createClass(Codec, [{
    key: "addSchema",
    value: function addSchema(schema) {
      exports.validateSchema(schema);
      var schemaName = schema.$id;
      this._compileSchemas[schemaName] = this._compileSchema(schema, [], []);
      return true;
    }
  }, {
    key: "encode",
    value: function encode(schema, message) {
      if (this._compileSchemas[schema.$id] === undefined) {
        this.addSchema(schema);
      }

      var compiledSchema = this._compileSchemas[schema.$id];
      var res = collection_1.writeObject(compiledSchema, message, []);
      return Buffer.concat(res[0]);
    }
  }, {
    key: "decode",
    value: function decode(schema, message) {
      if (this._compileSchemas[schema.$id] === undefined) {
        this.addSchema(schema);
      }

      var compiledSchema = this._compileSchemas[schema.$id];

      var _collection_1$readObj = collection_1.readObject(message, 0, compiledSchema, message.length),
          _collection_1$readObj2 = _slicedToArray(_collection_1$readObj, 1),
          res = _collection_1$readObj2[0];

      return res;
    }
  }, {
    key: "decodeJSON",
    value: function decodeJSON(schema, message) {
      var decodedMessage = this.decode(schema, message);
      var jsonMessageAsObject = this.toJSON(schema, decodedMessage);
      return jsonMessageAsObject;
    }
  }, {
    key: "encodeJSON",
    value: function encodeJSON(schema, message) {
      var objectFromJson = this.fromJSON(schema, message);
      return this.encode(schema, objectFromJson);
    }
  }, {
    key: "toJSON",
    value: function toJSON(schema, message) {
      var messageCopy = lisk_utils_1.objects.cloneDeep(message);
      messageCopy[Symbol.iterator] = json_wrapper_1.iterator;
      json_wrapper_1.recursiveTypeCast('toJSON', messageCopy, schema, []);
      return messageCopy;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(schema, message) {
      var messageCopy = lisk_utils_1.objects.cloneDeep(message);
      messageCopy[Symbol.iterator] = json_wrapper_1.iterator;
      json_wrapper_1.recursiveTypeCast('fromJSON', messageCopy, schema, []);
      return messageCopy;
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this._compileSchemas = {};
    }
  }, {
    key: "_compileSchema",
    value: function _compileSchema(schema, compiledSchema, dataPath) {
      if (schema.type === 'object') {
        var properties = schema.properties;

        if (properties === undefined) {
          throw new Error('Invalid schema. Missing "properties" property');
        }

        for (var _i = 0, _Object$values = Object.values(properties); _i < _Object$values.length; _i++) {
          var property = _Object$values[_i];

          if (!('fieldNumber' in property)) {
            throw new Error('Invalid schema. Missing "fieldNumber" in properties');
          }
        }

        var currentDepthSchema = Object.entries(properties).sort(function (a, b) {
          return a[1].fieldNumber - b[1].fieldNumber;
        });

        for (var i = 0; i < currentDepthSchema.length; i += 1) {
          var _currentDepthSchema$i = _slicedToArray(currentDepthSchema[i], 2),
              schemaPropertyName = _currentDepthSchema$i[0],
              schemaPropertyValue = _currentDepthSchema$i[1];

          if (schemaPropertyValue.type === 'object') {
            if (!('fieldNumber' in schemaPropertyValue)) {
              throw new Error('Invalid schema. Missing "fieldNumber" in properties');
            }

            dataPath.push(schemaPropertyName);
            var nestedSchema = [{
              propertyName: schemaPropertyName,
              schemaProp: {
                type: schemaPropertyValue.type,
                fieldNumber: schemaPropertyValue.fieldNumber
              },
              dataPath: _toConsumableArray(dataPath),
              binaryKey: utils_1.generateKey(schemaPropertyValue)
            }];

            var res = this._compileSchema(schemaPropertyValue, nestedSchema, dataPath);

            compiledSchema.push(res);
            dataPath.pop();
          } else if (schemaPropertyValue.type === 'array') {
            if (schemaPropertyValue.items === undefined) {
              throw new Error('Invalid schema. Missing "items" property for Array schema');
            }

            if (!('fieldNumber' in schemaPropertyValue)) {
              throw new Error('Invalid schema. Missing "fieldNumber" in properties');
            }

            dataPath.push(schemaPropertyName);

            if (schemaPropertyValue.items.type === 'object') {
              var _nestedSchema = [{
                propertyName: schemaPropertyName,
                schemaProp: {
                  type: 'object',
                  fieldNumber: schemaPropertyValue.fieldNumber
                },
                dataPath: _toConsumableArray(dataPath),
                binaryKey: utils_1.generateKey(schemaPropertyValue)
              }];

              var _res = this._compileSchema(schemaPropertyValue.items, _nestedSchema, dataPath);

              compiledSchema.push([{
                propertyName: schemaPropertyName,
                schemaProp: {
                  type: schemaPropertyValue.type,
                  fieldNumber: schemaPropertyValue.fieldNumber
                },
                dataPath: _toConsumableArray(dataPath),
                binaryKey: utils_1.generateKey(schemaPropertyValue)
              }, _res]);
              dataPath.pop();
            } else {
              compiledSchema.push([{
                propertyName: schemaPropertyName,
                schemaProp: {
                  type: schemaPropertyValue.type,
                  fieldNumber: schemaPropertyValue.fieldNumber
                },
                dataPath: _toConsumableArray(dataPath),
                binaryKey: utils_1.generateKey(schemaPropertyValue)
              }, {
                propertyName: schemaPropertyName,
                schemaProp: {
                  dataType: schemaPropertyValue.items.dataType,
                  fieldNumber: schemaPropertyValue.fieldNumber
                },
                dataPath: _toConsumableArray(dataPath),
                binaryKey: utils_1.generateKey(schemaPropertyValue)
              }]);
              dataPath.pop();
            }
          } else {
            compiledSchema.push({
              propertyName: schemaPropertyName,
              schemaProp: schemaPropertyValue,
              dataPath: _toConsumableArray(dataPath),
              binaryKey: utils_1.generateKey(schemaPropertyValue)
            });
          }
        }
      }

      return compiledSchema;
    }
  }]);

  return Codec;
}();

exports.Codec = Codec;
exports.codec = new Codec();